var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReserve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2568 8.86767H15.445C15.8294 8.86767 16.1176 8.48335 16.0215 8.09903L15.0928 5.12057C15.0287 4.86436 14.7725 4.70422 14.5163 4.70422H11.1855C10.9293 4.70422 10.7051 4.86436 10.609 5.12057L9.68027 8.09903C9.55217 8.48335 9.84041 8.86767 10.2568 8.86767Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5483 10.597L13.6195 13.5755C13.4914 13.9598 13.7796 14.3441 14.196 14.3441H19.3843C19.7686 14.3441 20.0568 13.9598 19.9608 13.5755L19.032 10.597C18.9679 10.3408 18.7117 10.1807 18.4555 10.1807H15.0927C14.8365 10.1807 14.6123 10.3408 14.5483 10.597Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34949 14.3441H11.5378C11.9221 14.3441 12.2103 13.9598 12.1143 13.5755L11.1214 10.597C11.0574 10.3408 10.8012 10.1807 10.545 10.1807H7.27826C7.02205 10.1807 6.79787 10.3408 6.70179 10.597L5.77302 13.5755C5.64491 13.9598 5.93315 14.3441 6.34949 14.3441Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.804 19.052L22.8752 16.0736C22.8111 15.8174 22.5549 15.6572 22.2987 15.6572H19.032C18.7758 15.6572 18.5516 15.8174 18.4555 16.0736L17.5268 19.052C17.3987 19.4364 17.6869 19.8207 18.1032 19.8207H23.2915C23.6438 19.8207 23.9321 19.4364 23.804 19.052Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4842 15.6572H11.1855C10.9293 15.6572 10.7051 15.8174 10.609 16.0736L9.68027 19.052C9.55217 19.4364 9.84041 19.8207 10.2568 19.8207H15.445C15.8294 19.8207 16.1176 19.4364 16.0215 19.052L15.0607 16.0736C14.9646 15.8174 14.7405 15.6572 14.4842 15.6572Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41026 19.8207H7.59855C7.98287 19.8207 8.27111 19.4364 8.17503 19.052L7.21423 16.0736C7.15018 15.8174 6.89397 15.6572 6.63776 15.6572H3.37105C3.11484 15.6572 2.89066 15.8174 2.79458 16.0736L1.86581 19.052C1.7377 19.4364 2.02594 19.8207 2.41026 19.8207Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserve);
export default __webpack_public_path__ + "static/media/reserve.a98490bc.svg";
export { ForwardRef as ReactComponent };